import { render } from "./etBtnDel.vue?vue&type=template&id=4633a4f9"
import script from "./etBtnDel.vue?vue&type=script&lang=js"
export * from "./etBtnDel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__